<template>
  <div class="text-gray-600 pb-10">
    <div class="text-center pb-10">
      <p class="ota-h3 mb-1" v-text="title" />
      <p class="ota-p16 mx-auto" v-text="description" />
    </div>
    <div class="relative bg-container">
      <OImage v-bind="bgImage" img-class="cover-image mx-auto" />
      <div class="absolute top-0 right-0 left-0 bottom-0 flex flex-col items-center justify-center pt-28 md:pt-12 md:flex-row">
        <div
          v-for="(name, index) in boxerNames"
          :key="`${name}-${index}`"
          class="mb-7 md:mx-10"
        >
          <OImage v-bind="getboxerImage(name)" img-class="halloween-featured-boxers" />
        </div>
      </div>
      <div class="absolute top-0 right-0 left-0 bottom-0 hidden">
        <OImage v-bind="fgImage" img-class="cover-image mx-auto md:hidden" />
      </div>
    </div>
    <div class="button-container text-center">
      <OButton
        variant="secondary"
        @click="$router.push($i18n.localePath({ name: link }))"
      >
        {{ cta }}
      </OButton>
    </div>
  </div>
</template>

<script>
import { getImagePaths } from '@/utils/general'
import OImage from '@/components/OImage'
import OButton from '@/components/OButton'

export default {
  name: 'FeaturedBoxers',
  components: { OImage, OButton },
  props: {
    link: {
      type: String,
      default: 'signup'
    }
  },
  computed: {
    title () {
      return this.$t('FeaturedBoxersCampaign.Title')
    },
    description () {
      return this.$t('FeaturedBoxersCampaign.Description')
    },
    cta () {
      return this.$t('FeaturedBoxersCampaign.CTA')
    },
    boxerNames () {
      return [
        'porch',
        'wicked'
      ]
    },
    bgImage () {
      return getImagePaths({
        path: '/images/frontend/try-now/halloween23/halloween',
        s3: true
      })
    },
    fgImage () {
      return getImagePaths({
        path: '/images/frontend/try-now/halloween23/halloween-bats',
        s3: true,
        noDesktop: true
      })
    }
  },
  methods: {
    getboxerImage (boxerName = 'fury') {
      return getImagePaths({ path: `/images/design/${boxerName}/products/${boxerName}-men-originals-boxershort`, s3: true, noMobile: true })
    }
  }
}
</script>

<style lang="postcss" scoped>
.oimage >>> img {
  max-width: 100% !important;

  &.cover-image {
    max-height: 91rem;
  }

  &.halloween-featured-boxers {
    max-width: 100% !important;
  }
}

.ota-p16 {
  max-width: 40.8rem;
}

.button-container {
  margin-top: 3rem;
}

@screen md {
  .bg-container {
    margin-top: -2rem;
  }

  .oimage >>> img {
    &.halloween-featured-boxers {
      max-width: 23rem !important;
    }
  }
}

@screen lg {
  .bg-container {
    margin-top: -3rem;
  }

  .button-container {
    margin-top: -4rem;
  }
}
</style>
